import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  banner: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    justifyContent: 'space-between',
    color: theme.colors.light.freshPowder,
    borderRadius: 10,
    backgroundColor: theme.colors.orange.orangeSemiTransparent,
  },
  logoTextPart: {
    display: 'flex',
    alignItems: 'center',
  },
  logoWrapper: {
    marginRight: 16,
  },
  logoImg: {
    filter:
      'drop-shadow(0px 10.7404px 95.4699px rgba(255, 155, 7, 0.134329)) drop-shadow(0px 4.9656px 44.1386px rgba(255, 155, 7, 0.194074)) drop-shadow(0px 2.8412px 25.2551px rgba(255, 155, 7, 0.239227)) drop-shadow(0px 1.72459px 15.3297px rgba(255, 155, 7, 0.280773)) drop-shadow(0px 1.03914px 9.2368px rgba(255, 155, 7, 0.325926)) drop-shadow(0px 0.578661px 5.14365px rgba(255, 155, 7, 0.385671)) drop-shadow(0px 0.248878px 2.21225px rgba(255, 155, 7, 0.52))',
  },
  text: {
    marginRight: 30,
  },
}));

export const useStylesButton = makeStyles(theme => ({
  root: {
    minWidth: 'unset',
    height: 35,
    marginBottom: 0,
    fontSize: theme.fonts.sizes.font12PX,
    color: theme.colors.light.freshPowder,
    borderRadius: 50,
    backgroundColor: theme.colors.orange.orange,

    '&:hover': {
      color: theme.colors.light.freshPowder,
      backgroundColor: theme.colors.orange.orange,
    },
  },
}));
